import React from "react";
import { TDSLogo } from "../../config/images";


const AboutContent = (props) => {
	return (
		<div className="about-content bg-white">
			<div className="container">
                <div className="col-12 col-md-7 col-lg-8 about-text-wrap">
                    <div>
                        <div className="about-section">
                            <h3 className="about-heading text-24 mb-3">What is the Gateway?</h3>
                            <p className="about-desc mb-3">
                                "My Housing Issue" Gateway is a website used by thousands of private and social housing tenants each month to resolve their housing problems.
                            </p>
                            <p className="about-desc mb-3">
                                It helps people find a clear path to the appropriate forum for making complaints and resolving issues.
                            </p>
                            <p className="about-desc mb-3">
                                It's also an important tool to help tenants get to know their housing rights and available options.
                            </p>
                        </div>

                        <div className="about-section">
                            <h3 className="about-heading text-24 mb-3">Why is it needed?</h3>
                            <p className="about-desc">
                                There are many places to go to for help with housing issues, like councils, courts, ombudsman schemes, and more. This can make it confusing and hard to know where to start.
                            </p>
                            <p className="about-desc1">Research shows that:</p>
                            <ul className="about-desc list">
                                <li>Very few tenants (18%) took their complaints to a local authority or another scheme when their issues were not resolved</li>
                                <li>41% of tenants did not know where to turn if their landlord or letting agent failed to address a problem</li>
                            </ul>
							<p className="about-desc2">Online information can be overwhelming or incorrect and this can waste your time. As a result, issues often remain unresolved.</p>
                            <p className="about-desc">
                                The "My Housing Issue" Gateway makes the process of finding and getting help simpler and easier.
                            </p>
                        </div>

                        <div className="about-section">
                            <h3 className="about-heading text-24 mb-3">Who is the TDS Charitable Foundation?</h3>
                            <p className="about-desc mb-3">
                                The TDS Charitable Foundation aims to improve standards in the private renting sector. It works to advance education about housing rights and obligations in general and encourage more efficient and effective resolution of disputes between landlords and tenants.
                            </p>
                            <p className="about-desc mb-3">
                                It is funded mainly by donations from The Dispute Service (TDS) – the leading Tenancy Deposit Scheme which operates on a non-profit basis across the UK. It operates in England and Wales and has funded organisations and projects across all regions.
                            </p>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	);
};

export default AboutContent;